import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './i18n/locales/de/app.json';
import en from './i18n/locales/en/app.json';

// German-first (the users are German farmers); English fallback.
void i18n.use(initReactI18next).init({
  resources: { de: { app: de }, en: { app: en } },
  lng: 'de',
  fallbackLng: 'en',
  defaultNS: 'app',
  interpolation: { escapeValue: false },
});

export default i18n;
